const uppercaseFirstLetter = (str) => str?.[0]?.toUpperCase() + str?.slice(1);

export default uppercaseFirstLetter;
